import {useEffect, useState} from 'react';
import {Tooltip} from 'react-tooltip';
import {Location} from '@reach/router';
import * as styles from './feedbackContainer.module.css';
import ButtonIcon from '../../core/button/buttonIcon';
import {WarningIcon} from '../../core/icons';
import ReportFeedbackModal from '../../../modals/feedback/reportFeedback';
import useLocalStorage from '../../../hooks/useLocalStorage';

const FeedbackContainer = () => {
    const [modal, setModal] = useState(false);
    const [showTooltip, setShowTooltip] = useLocalStorage<boolean>('feedbackTooltipVisibility', true);

    const closeModal = () => setModal(false);
    const openModal = () => {
        setModal(true);
        setShowTooltip(false);
    };
    const tooltipId = 'feedback-tooltip';

    const tooltipContent = (
        <div className={styles.tooltipContent}>
            <p className={styles.tooltipMessage}>
                Do you have a question, issue, or feedback? Click the (!) button in the corner to contact us — it’s available on every page.
            </p>
        </div>
    );

    useEffect(() => {
        setShowTooltip(true);
    }, [setShowTooltip]);

    if (!modal) {
        return (
            <Location>
                {({location}) => {
                    if (location.pathname !== '/' && !localStorage.accountState) {
                        return null;
                    }

                    return (
                        <>
                            <ButtonIcon
                                data-tooltip-id={tooltipId}
                                data-tooltip-position-strategy="fixed"
                                className={styles.feedbackButton}
                                icon={WarningIcon}
                                tooltipText="Send feedback"
                                onClick={() => {
                                    openModal();
                                }}
                                onMouseEnter={() => {
                                    setShowTooltip(false);
                                }}
                            />

                            <Tooltip
                                id={tooltipId}
                                positionStrategy="fixed"
                                isOpen={location.pathname === '/' && showTooltip}
                                place="bottom"
                                clickable={true}
                                delayShow={1000}
                                delayHide={1000}
                                style={{
                                    borderRadius: 'var(--border-radius-form)',
                                    backgroundColor: 'var(--color-main-blue)',
                                }}
                            >
                                {tooltipContent}
                            </Tooltip>

                        </>
                    );
                }}
            </Location>

        );
    }

    return <ReportFeedbackModal closeModal={closeModal} />;
};

export default FeedbackContainer;
